/**
 * YoYControls
 *
 * Filter controls for the Year-over-Year tab:
 * - Professional selector (all or single attorney)
 * - Granularity toggle (weekly / monthly)
 * - Go-live info panel (replaces the old date range selector)
 */

import {
  Tabs,
  TabsList,
  TabsTrigger,
} from "@/shared/components/ui/tabs";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { YoYGranularity } from "../../types/dashboard";

interface Professional {
  prof_id: string;
  full_name: string;
}

interface YoYControlsProps {
  professionals: Professional[];
  profId: string | null;
  onProfIdChange: (profId: string | null) => void;
  granularity: YoYGranularity;
  onGranularityChange: (g: YoYGranularity) => void;
}

export default function YoYControls({
  professionals,
  profId,
  onProfIdChange,
  granularity,
  onGranularityChange,
}: YoYControlsProps) {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Professional selector */}
        <div>
          <label className="text-xs font-medium text-muted-foreground mb-1 block">
            Professional
          </label>
          <Select
            value={profId ?? "__all__"}
            onValueChange={(val) =>
              onProfIdChange(val === "__all__" ? null : val)
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">All Professionals</SelectItem>
              {professionals.map((p) => (
                <SelectItem key={p.prof_id} value={p.prof_id}>
                  {p.full_name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Granularity toggle */}
        <div>
          <label className="text-xs font-medium text-muted-foreground mb-1 block">
            View
          </label>
          <Tabs
            value={granularity}
            onValueChange={(v) => onGranularityChange(v as YoYGranularity)}
            className="w-full"
          >
            <TabsList className="w-full h-10 border border-border">
              <TabsTrigger
                value="daily"
                disabled={!profId}
                title={!profId ? "Select a specific attorney to use daily view" : undefined}
                className="flex-1 h-full rounded-none rounded-l-md data-[state=active]:border data-[state=active]:border-border"
              >
                Daily
              </TabsTrigger>
              <TabsTrigger
                value="weekly"
                className="flex-1 h-full rounded-none data-[state=active]:border data-[state=active]:border-border"
              >
                Weekly
              </TabsTrigger>
              <TabsTrigger
                value="monthly"
                className="flex-1 h-full rounded-none rounded-r-md data-[state=active]:border data-[state=active]:border-border"
              >
                Monthly
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </div>

    </div>
  );
}
